import React from 'react';
import PropTypes from 'prop-types';
import ItemClusterLevel from "./ItemClusterLevel";
import SelectedItemDetail from "./SelectedItemDetail";
import {camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";
import {levelIsEnabled} from "../../../logic/ClusterLevels";
import ItemClusterSelectorsList from "../../StandardItems/ItemClusterSelectorsList";
import ProductSpecsDisplay from "../../GroupItems/ProductSpecsDisplay";
import ClusterSpecsTableAdapter from "./ClusterSpecsTableAdapter";

/*
 * ItemClusterMain - the "widgets" component of a cluster, with
 * the selectors; the central of the three columns.
 *
 */
export default function ItemClusterMain({
  cluster, clusterState, itemCache, productAttributes, allProductSpecs=[]
}) {
  const selectedItem = camelizeKeysDeep(clusterState.selectedItem);

  return <div className="min-h-1">
    <h3 className="text-brand-primary text-xl lg:h-14 m-0 p-0">{cluster.headline}</h3>

    <ItemClusterSelectorsList
      itemCache={itemCache}
      productAttributes={productAttributes}
      cluster={cluster}
      clusterState={clusterState} />

    {selectedItem && <SelectedItemDetail item={selectedItem} />}

    <ClusterSpecsTableAdapter
      cluster={cluster}
      clusterState={clusterState}
      allProductSpecs={allProductSpecs}/>

  </div>
}

ItemClusterMain.propTypes = {
  clusterState: PropTypes.object
}
